import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { SxProps } from "@mui/material";

interface ModalDetails {
  children?: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  width?: number;
  height?: number;
  fullScreenMobile?: boolean;
  mobileWidth?: number;
  mobileHeight?: number;
  onClose?: () => void;
  sx?: SxProps;
}

const BasicModal: React.FC<ModalDetails> = ({
  children,
  open,
  setOpen,
  width,
  height,
  mobileHeight,
  mobileWidth,
  fullScreenMobile = false,
  onClose,
  sx,
}) => {
  const handleClose = () => {
    onClose && onClose();
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={sx}
    >
      <Box
        sx={{
          position: "absolute",
          minHeight: { tablet: "200px" },
          maxHeight: {
            desktop: "90vh",
            tablet: "80vh",
            mobile: "100vh",
          },
          maxWidth: { mobile: "100%" },
          top: "50%",
          left: "50%",
          display: "flex",
          flexDirection: "column",
          transform: "translate(-50%, -50%)",
          borderRadius: "10px",
          bgcolor: "background.paper",
          overflow: "auto",
          width: {
            desktop: width ? `${width}px` : "fit-content",
            tablet: width ? `${width}px` : "fit-content",
            mobile: fullScreenMobile
              ? "100vw"
              : mobileWidth
              ? `${mobileWidth}px`
              : "90vw",
          },
          height: {
            desktop: height ? `${height}px` : "auto",
            tablet: height ? `${height}px` : "auto",
            mobile: fullScreenMobile
              ? "100%"
              : mobileHeight
              ? `${mobileHeight}px`
              : "auto",
          },
          WebkitOverflowScrolling: "touch",
          overscrollBehavior: "contain",

          "&:focus": {
            outline: "none",
          },
        }}
      >
        {children}
      </Box>
    </Modal>
  );
};

export default BasicModal;
